import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { submitSaqyaDemande } from '../services/kafalaService';
import './SaqyaWellRequest.css';

const emptyForm = {
  first_name: '',
  last_name: '',
  phone: '',
  ville: '',
  well_sponsorship: '',
};

const SaqyaWellRequest = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  const onChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess(false);
    if (!form.well_sponsorship) {
      setError(t('saqyaForm.chooseWell'));
      return;
    }
    setSaving(true);
    try {
      await submitSaqyaDemande(form);
      setForm(emptyForm);
      setSuccess(true);
    } catch (err) {
      const data = err.response?.data;
      setError(data?.message || t('saqyaForm.sendError'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <section id="well-request" className="program-section program-section--alt saqya-well">
      <div className="program-section__inner saqya-well__inner">
        <h2 className="program-section__title">{t('saqyaForm.sectionTitle')}</h2>
        <p className="saqya-well__intro">{t('saqyaForm.sectionIntro')}</p>
        <button type="button" className="saqya-well__cta" onClick={() => { setOpen(true); setSuccess(false); setError(''); }}>
          {t('saqyaForm.button')}
        </button>
      </div>

      {open ? (
        <div className="saqya-well-modal" onClick={() => setOpen(false)} role="presentation">
          <div
            className="saqya-well-modal__dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="saqya-well-title"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="saqya-well-modal__x"
              onClick={() => setOpen(false)}
              aria-label={t('saqyaForm.close')}
            >
              <FaTimes />
            </button>
            <h3 id="saqya-well-title">{t('saqyaForm.title')}</h3>
            <form onSubmit={onSubmit} className="saqya-well-modal__form">
              <label>
                {t('saqyaForm.lastName')}
                <input name="last_name" value={form.last_name} onChange={onChange} required />
              </label>
              <label>
                {t('saqyaForm.firstName')}
                <input name="first_name" value={form.first_name} onChange={onChange} required />
              </label>
              <label>
                {t('saqyaForm.phone')}
                <input name="phone" type="tel" value={form.phone} onChange={onChange} required dir="ltr" />
              </label>
              <label>
                {t('saqyaForm.city')}
                <input name="ville" value={form.ville} onChange={onChange} required />
              </label>
              <fieldset>
                <legend>{t('saqyaForm.wellLabel')}</legend>
                <div className="saqya-well-modal__radios">
                  <label className="saqya-well-modal__radio">
                    <input
                      type="radio"
                      name="well_sponsorship"
                      value="full"
                      checked={form.well_sponsorship === 'full'}
                      onChange={onChange}
                    />
                    <span>{t('saqyaForm.wellFull')}</span>
                  </label>
                  <label className="saqya-well-modal__radio">
                    <input
                      type="radio"
                      name="well_sponsorship"
                      value="partial"
                      checked={form.well_sponsorship === 'partial'}
                      onChange={onChange}
                    />
                    <span>{t('saqyaForm.wellPartial')}</span>
                  </label>
                </div>
              </fieldset>
              {error ? <p className="saqya-well-modal__error">{error}</p> : null}
              {success ? <p className="saqya-well-modal__success">{t('saqyaForm.success')}</p> : null}
              <button type="submit" disabled={saving}>
                {saving ? t('saqyaForm.sending') : t('saqyaForm.submit')}
              </button>
            </form>
          </div>
        </div>
      ) : null}
    </section>
  );
};

export default SaqyaWellRequest;
